var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"nrk"},[_c('Nav-English')],1),_c('router-view'),_c('BottomNavigation',{attrs:{"kiss":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }